import LoadingModule from '@components/loadingModule';
import NotFound from '@components/notFound';
import createCustomHistory from '@history/customHistory';
import { routeTree } from '@routeTree.gen';
import { createRouter } from '@tanstack/react-router';

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}

declare module '@tanstack/react-router' {
  interface HistoryState {
    fromScanner?: boolean;
  }
}

const router = createRouter({
  routeTree,
  history: createCustomHistory(),
  scrollRestoration: true,
  defaultPendingComponent: LoadingModule,
  defaultPendingMinMs: 0,
  defaultPendingMs: 0,
  defaultNotFoundComponent: NotFound,
  defaultPreload: 'render',
});

export default router;
